import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AppsIcon from "@mui/icons-material/Apps";
import DnsIcon from "@mui/icons-material/Dns";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import LoginIcon from "@mui/icons-material/Login";
import PreviewIcon from "@mui/icons-material/Preview";

export interface NavItem {
  label: string;
  path: string;
  icon: React.ReactElement;
  requiresAuth: boolean;
  badge?: number;
}

export const DRAWER_WIDTH = 256;

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Home",
    path: "/",
    icon: React.createElement(HomeIcon),
    requiresAuth: false,
  },
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: React.createElement(DashboardIcon),
    requiresAuth: true,
  },
  {
    label: "Preview",
    path: "/preview",
    icon: React.createElement(PreviewIcon),
    requiresAuth: false,
  },
  {
    label: "Services",
    path: "/services",
    icon: React.createElement(AppsIcon),
    requiresAuth: false,
  },
  {
    label: "My Instances",
    path: "/instances",
    icon: React.createElement(DnsIcon),
    requiresAuth: true,
  },
  {
    label: "Settings",
    path: "/settings",
    icon: React.createElement(SettingsIcon),
    requiresAuth: true,
  },
];

export const LOGIN_NAV_ITEM: NavItem = {
  label: "Sign In",
  path: "/login",
  icon: React.createElement(LoginIcon),
  requiresAuth: false,
};
